import type { ReactNode } from "react";

/**
 * Standard hero block at the top of every onboarding step.
 * Eyebrow → title → subtitle. The eyebrow is the small all-caps
 * "STEP 2 OF 5" rail; omit it on Welcome / Done (those have no
 * step counter).
 */
export function StepHero({
  eyebrow,
  title,
  subtitle,
}: {
  eyebrow?: string;
  title: string;
  subtitle?: ReactNode;
}) {
  return (
    <div className="space-y-3">
      {eyebrow && (
        <p className="text-[11px] font-semibold tracking-[0.16em] uppercase text-muted-foreground">
          {eyebrow}
        </p>
      )}
      <h1 className="text-[32px] font-bold tracking-tight leading-[1.15] text-foreground">
        {title}
      </h1>
      {subtitle && (
        <p className="text-[15px] leading-relaxed text-muted-foreground max-w-[600px]">
          {subtitle}
        </p>
      )}
    </div>
  );
}
